import $http from '$http'
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';

export default {
    methods: {
        //提交修改
        //UpdateAgentAccountEx
        submit(prams) {
            $http.post('api/Agent/UpdateAgentAccountEx', prams).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.$emit('reloadList'); // 向上派发 toggle事件
                });
            });
        },
        //获取收款账户下拉列表
        getAccountTypeData(agentId, accountType) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                agentId: agentId,
                accountType: accountType
            };
            $http.get('api/Agent/GetModifyAgentAccountList', params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    console.log(Data)
                    this.accountTypes = Data
                });
            });

        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/components/changeMoney/services.js